// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"208":"invalid","420":"message","772":"cookies"}[chunkId] + "." + {"208":"ae3aa82f","420":"97297ddc","772":"d330cf79"}[chunkId] + ".css";
};